import React from 'react';
import PropTypes from 'prop-types';
import set from 'lodash/set';
import get from 'lodash/get';

import ColorPickerEditor from 'common/components/ColorPicker';
import { useNode } from '@splashthat/splash-cms-engine';

const FIRST_COLOR_LABEL = 'Default';
const SECOND_COLOR_LABEL = 'Hover';
const TRANSPARENT_FALLBACK = { value: 'transparent' };

export default function BackgroundColorTools({
    colors,
    backgroundColorPath,
    backgroundColorHoverPath,
    ariaLabel,
    qaId,
    hasHover,
}) {
    const node = useNode();
    const colorList = colors.map((color, index) => ({
        id: index,
        value: color,
    }));

    const updateBackgroundColor = (id) =>
        node.actions.setProp((editedNode) => {
            set(editedNode, backgroundColorPath, id);
            return editedNode;
        });

    const updateBackgroundHoverColor = (id) =>
        node.actions.setProp((editedNode) => {
            set(editedNode, backgroundColorHoverPath, id);
            return editedNode;
        });

    const hoverProps = hasHover
        ? {
              // We don't include a label on the first color if there is no second color
              firstColorLabel: FIRST_COLOR_LABEL,
              secondColorLabel: SECOND_COLOR_LABEL,
              secondColor: colorList[get(node, backgroundColorHoverPath)] || TRANSPARENT_FALLBACK,
              changeSecondColor: updateBackgroundHoverColor,
          }
        : {};

    return (
        <ColorPickerEditor
            colorList={colorList}
            firstColor={colorList[get(node, backgroundColorPath)] || TRANSPARENT_FALLBACK}
            changeFirstColor={updateBackgroundColor}
            aria-label={`${ariaLabel} Default Color`}
            qaId={qaId || `${node.id}-background-color-picker`}
            {...hoverProps}
        />
    );
}

BackgroundColorTools.propTypes = {
    colors: PropTypes.array.isRequired,
    backgroundColorPath: PropTypes.string,
    backgroundColorHoverPath: PropTypes.string,
    ariaLabel: PropTypes.string,
    qaId: PropTypes.string,
    hasHover: PropTypes.bool,
};

BackgroundColorTools.defaultProps = {
    backgroundColorPath: 'styles.backgroundColor',
    backgroundColorHoverPath: 'styles.backgroundColorHover',
    ariaLabel: '',
    qaId: '',
    hasHover: false,
};
